import isEmpty from 'lodash/isEmpty';
import { Autocomplete, TextField } from '@mui/material';
import { Credit } from 'lib/types/credits';
import { InputAdornmentCheck } from 'elements/InputAdornmentCheck';

interface Props {
  credits: Credit[];
  value: Credit | null;
  onChange: (value: Credit|null) => void;
}

export const CreditSelect = ({
  credits, value, onChange,
}: Props) => (
  <Autocomplete
    id="credit-select"
    options={credits}
    onChange={(_, v) => onChange(v)}
    value={value}
    getOptionLabel={(option) => (isEmpty(option) ? '' : `${option.user.name}, ${option.role.name}`)}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Credit"
        variant="outlined"
        InputProps={{
          ...params.InputProps,
          startAdornment: value ? <InputAdornmentCheck /> : null,
        }}
      />
    )}
  />

);
